module.exports = __webpack_public_path__ + "static/media/add.40cc0e47.svg";